import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = props => <>
  <TableCell align='center'><TextHeader label={I18n.t('date.label', { count: 1 })} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('event.label', { count: 1 })} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('order.label.alter')} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('driver.label', { count: 1 })} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('vehicle.plaque')} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('contract.license_id')} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('contract.id')} /></TableCell>
</>

export default React.memo(Header)
